/**
 * Toast 通知容器 — 固定在右下角，从 toastStore 读取并渲染
 */
import React from 'react';
import { useToastStore, type Toast, type ToastType } from '../store/toastStore';

const iconMap: Record<ToastType, string> = {
  success: '✓',
  error: '✕',
  info: 'ℹ',
  warning: '⚠',
};

const colorMap: Record<ToastType, { bg: string; border: string; text: string; iconBg: string }> = {
  success: { bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-800', iconBg: 'bg-emerald-100 text-emerald-600' },
  error: { bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-800', iconBg: 'bg-red-100 text-red-600' },
  info: { bg: 'bg-brand-50', border: 'border-brand-200', text: 'text-brand-700', iconBg: 'bg-brand-100 text-brand-600' },
  warning: { bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-800', iconBg: 'bg-amber-100 text-amber-600' },
};

const ToastItem: React.FC<{ toast: Toast }> = ({ toast }) => {
  const removeToast = useToastStore((s) => s.removeToast);
  const colors = colorMap[toast.type];

  return (
    <div
      className={`flex items-start gap-3 w-80 p-3 rounded-xl border shadow-modal ${colors.bg} ${colors.border} animate-slide-in-right`}
      role="alert"
    >
      <span
        className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${colors.iconBg}`}
      >
        {iconMap[toast.type]}
      </span>
      <div className="flex-1 min-w-0">
        {toast.title && (
          <p className={`text-sm font-semibold ${colors.text}`}>{toast.title}</p>
        )}
        <p className={`text-sm ${colors.text} break-words`}>{toast.message}</p>
      </div>
      <button
        onClick={() => removeToast(toast.id)}
        className="flex-shrink-0 text-slate-400 hover:text-slate-600 text-sm leading-none"
        aria-label="关闭"
      >
        ✕
      </button>
    </div>
  );
};

const ToastContainer: React.FC = () => {
  const toasts = useToastStore((s) => s.toasts);

  return (
    <div className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none">
      {toasts.map((t) => (
        <div key={t.id} className="pointer-events-auto">
          <ToastItem toast={t} />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
